export default {
    data() {
        return {
            windowObjectReference: null,
            previousUrl: null
        }
    },
    methods: {
        fullUrl(url) {
            var path = url.match(/^https?:\/\//i) ? url : process.env.VUE_APP_SERVER_URL + url
            return path
        },
        redirect_with_loader(url) {
            this.$root.loader = true
            this.$router.push(url)
        },
        redirect_to(url, time_right = 0) {
            setTimeout(function () {
                window.location.href = this.fullUrl(url)
            }, time_right)
        },
        /**
         *
         * @arg {Number} w
         * @arg {Number} h
         * @see http://www.xtf.dk
         */
        getPopupOptions(w, h) {
            var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
            var l = (width / 2) - (w / 2);
            var t = (height / 2) - (h / 2);

            return 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,width=' + w + ',height=' + h + ',top=' + t + ',left=' + l
        },

        openRequestedSinglePopup(strUrl, pageName, onClose) {
            var popupOptions = this.getPopupOptions(550, 550)

            if (this.windowObjectReference === null || this.windowObjectReference.closed) {
                this.windowObjectReference = window.open(strUrl, pageName, popupOptions);
                if (onClose) {
                    this.windowObjectReference.onbeforeunload = this.windowObjectReference.onunload = onClose
                }
            } else if (this.previousUrl != strUrl) {
                this.windowObjectReference = window.open(strUrl, pageName, popupOptions);
                if (onClose) {
                    this.windowObjectReference.onbeforeunload = this.windowObjectReference.onunload = onClose
                }
                this.windowObjectReference.focus();
            } else {
                this.windowObjectReference.focus();
            }

            this.previousUrl = strUrl;
        },
    }
}
